/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_Next_SectionInputs */

const en_playbar_next_section = /** @type {(inputs: Playbar_Next_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward 30s`)
};

const es_playbar_next_section = /** @type {(inputs: Playbar_Next_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzar 30 s`)
};

/**
* | output |
* | --- |
* | "Forward 30s" |
*
* @param {Playbar_Next_SectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_next_section = /** @type {((inputs?: Playbar_Next_SectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_Next_SectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_next_section(inputs)
	return en_playbar_next_section(inputs)
});